import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    console.log('🔍 ProductPrice updatePrice called');
    console.log('🔍 Event detail:', event.detail);
    
    if (!event.detail?.data?.html) {
      console.log('🔍 No HTML data in event');
      return;
    }

    console.log('🔍 Event HTML body:', event.detail.data.html.body.innerHTML);

    // Try to find the new price element in the event data
    let newPrice = event.detail.data.html.querySelector('product-price .price-with-savings');
    let currentPrice = this.querySelector('.price-with-savings');
    
    console.log('🔍 Looking for product-price .price-with-savings in event HTML');
    console.log('🔍 Found newPrice:', !!newPrice);
    console.log('🔍 Found currentPrice:', !!currentPrice);
    
    // Fallback to priceContainer if price-with-savings doesn't exist
    if (!newPrice || !currentPrice) {
      console.log('🔍 Trying fallback to [ref="priceContainer"]');
      newPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
      currentPrice = this.querySelector('[ref="priceContainer"]');
      console.log('🔍 Fallback newPrice:', !!newPrice);
      console.log('🔍 Fallback currentPrice:', !!currentPrice);
    }

    if (!newPrice || !currentPrice) {
      console.log('🔍 Missing price elements - newPrice:', !!newPrice, 'currentPrice:', !!currentPrice);
      console.log('🔍 Available elements in event HTML:');
      const allElements = event.detail.data.html.querySelectorAll('*');
      allElements.forEach(el => console.log('🔍 Element:', el.tagName, el.className, el.getAttribute('ref')));
      return;
    }

    console.log('🔍 New price innerHTML:', newPrice.innerHTML);
    console.log('🔍 Current price innerHTML:', currentPrice.innerHTML);

    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      console.log('🔍 Replacing price container');
      currentPrice.replaceWith(newPrice);
      console.log('🔍 Price container replaced successfully');
    } else {
      console.log('🔍 Price HTML is the same, no update needed');
    }
  };
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
